<template lang="pug">
.adult-avatar
  .avatar(@click="onCheck")
    img(:src="user.avatar")
  .instruction 我
  .warning(v-if="user && user.vspFaceStatus !== 1") 点击头像<br/>进行人脸核验
  
</template>
<script>
import IconPlus from '@/components/res/IconPlus'
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'AdultAvatarSelf',
  components: { IconPlus },
  props: {},
  data() {
    return {}
  },
  computed: {
    ...mapState('app', ['fam', 'user']),
  },
  methods: {
    onCheck() {
      if (this.user.vspFaceStatus !== 1) {
        this.$emit('verify', this.user.id)
      }
    },
  },
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.adult-avatar
  width: 100%
  .avatar
    margin-left:  pxToRem(60)
    width: pxToRem(180)
    height: pxToRem(180)
    box-shadow: pxToRem(-10) pxToRem(-10) pxToRem(17) 0 rgba(255,255,255,0.02), pxToRem(-19) pxToRem(-10) pxToRem(23) 0 rgba(252,252,252,0.74), pxToRem(-12) pxToRem(8) pxToRem(17) 0 rgba(252,252,252,0.35), pxToRem(2) pxToRem(13) pxToRem(43) 0 rgba(228,228,228,0.80)
    border-radius: pxToRem(90)
    background: #ffffff
    display: flex
    justify-content: center
    align-items: center
    overflow: hidden
    border: white pxToRem(10) solid
    img
      width: 100%
    .placeholder
      width: pxToRem(36)
      height: pxToRem(36)
      line-height: 0
  .instruction
    font-size: pxToRem(30)
    text-align: center
    margin-top: pxToRem(20)
  .warning
    font-size: pxToRem(36)
    text-align: center
    margin-top: pxToRem(-5)
    color: #e15125
</style>
